const getReportsApi = () =>
  process.env[
    `REACT_APP_REPORTS_API_${process.env.REACT_APP_API}`.toUpperCase()
  ];

const getReportsApiKey = () =>
  process.env[
    `REACT_APP_REPORTS_API_KEY_${process.env.REACT_APP_API}`.toUpperCase()
  ];

const getAccountsApi = () =>
  process.env[
    `REACT_APP_ACCOUNTS_API_${process.env.REACT_APP_API}`.toUpperCase()
  ];

const getAccountsApiKey = () =>
  process.env[
    `REACT_APP_ACCOUNTS_API_KEY_${process.env.REACT_APP_API}`.toUpperCase()
  ];

const getBuildersApi = () =>
  process.env[
    `REACT_APP_BUILDERS_API_${process.env.REACT_APP_API}`.toUpperCase()
  ];

const getBuildersApiKey = () =>
  process.env[
    `REACT_APP_BUILDERS_API_KEY_${process.env.REACT_APP_API}`.toUpperCase()
  ];

export const REPORTS_API_KEY = getReportsApiKey();
export const JOB_NOTE_RESOURCE = `${getReportsApi()}/job-notes`;

const API_URL_ACCOUNTS = getAccountsApi();
export const API_KEY_ACCOUNTS = getAccountsApiKey();

export const API_URL_JOBS = getBuildersApi();
export const API_KEY_JOBS = getBuildersApiKey();

// TODO - replace /login with /<mybuilderRouteName>
export const LOGIN_API = `${API_URL_ACCOUNTS}/login/cx-admin`;
export const SEARCH_API = `${API_URL_ACCOUNTS}/admin/search`;
export const PENDING_USERS_API = `${API_URL_JOBS}/admin/businesses/pendingUsers`;
export const PENDING_USERS_SEARCH_API = `${API_URL_JOBS}/admin/businesses/awaitingApprovalSearch`;
export const APPROVE_USERS_API = `${API_URL_JOBS}/admin/businesses/approve`;
export const REJECT_USERS_API = `${API_URL_JOBS}/admin/businesses/deactivate`;
export const UPDATE_USER_API = `${API_URL_ACCOUNTS}/admin/user`;
export const GET_BUSINESS_INFO = `${API_URL_JOBS}/users`;

export const GET_SKILLSET_OPTIONS_API = `${API_URL_ACCOUNTS}/skillset`;
export const GET_USER_ATTRIBUTES = `${API_URL_ACCOUNTS}/admin/user`;
export const UPDATE_USER_PROFILE_API = `${API_URL_ACCOUNTS}/admin/user`;
export const PENDING_PHOTOS_APIS = `${API_URL_JOBS}/builders/images`;
export const APPROVE_IMAGE = `${API_URL_JOBS}/builders/image-approve`;
export const UPLOAD_API = `${API_URL_JOBS}/builders/upload`;

// *************************************************************
// Colours
// *************************************************************
export const COLORS = {
  GREY_LIGHTER: '#DEE6E6',
  GREY_LIGHT: '#a7a9ab',
  GREY: '#dfe3e6',
  GREY_DARK: '#4D4D4D',
  GREY_DARKER: '#333333',
  WHITE: '#FFFFFF',
  WHITE_DARK: '#fbfcfc',
  BLUE: '#2090fb',
  BLUE_LIGHT: '#86bbe6',
  BLUE_DARK: '#4390F3',
  BLACK: '#000000',
  GREEN: '#009a44',
  GREEN_LIGHT: '#83be52',
  RED: '#f44336',
  YELLOW_DARK: '#f5a623',
};

// *************************************************************
// Fonts
// *************************************************************
export const FONTS = {
  PRIMARY: '"Helvetica Neue", Arial',
  SECONDARY: '"Montserrat", Arial',
  THIRD: '"CasualDe", Arial',
};

// *************************************************************
// Service Areas
// *************************************************************
export const SERVICE_AREAS = {
  LOCAL: 'local',
  STATEWIDE: 'statewide',
  NATIONAL: 'national',
};

export const BUILDER_DEACTIVATE_REASONS = [
  { name: 'Invalid', value: 'Invalid' },
  { name: 'Does not want leads', value: 'Does not want leads' },
  { name: 'Temporarily paused', value: 'Temporarily paused' },
  { name: 'Others', value: 'Others' },
];

export const FORMS = {
  REGISTRATION_LONG: 'registration-long-form',
  REGISTRATION_SHORT: 'registration-short-form',
  BUILDER_PROFILE_PERSONAL: 'builder-profile-personal',
  BUILDER_PROFILE_BUSINESS: 'builder-profile-business',
  BUILDER_LICENSE_EXPIRY: 'builder-license-expiry',
  UPDATE_SERVICE_AREA: 'update-service-area',
  JOB_FORM: 'job-form',
  RESEND_VERIFICATION_EMAIL_FORM: 'resend-verification-email-form',
  BUILDER_PROFILE_ADDITIONAL: 'builder-profile-additional',
};

export const VIEWABLE_FORM_MODES = {
  EDITING: 'editing',
  VIEWING: 'viewing',
};

// *************************************************************
// User Profile Type
// *************************************************************
export const USER_PROFILE_TYPES = {
  PERSONAL: 'personal',
  BUSINESS: 'business',
  SERVICE_AREA: 'service_area',
  ADDITIONAL: 'additional',
};

export const AUS_CENTER = {
  lat: -30,
  lng: 133,
};

export const AUS_STATES = [
  {
    short_name: 'NSW',
    long_name: 'New South Wales',
    center_location: {
      lat: -33,
      lng: 147,
    },
    zoom_level: 6,
  },
  {
    short_name: 'QLD',
    long_name: 'Queensland',
    center_location: {
      lat: -20,
      lng: 145,
    },
    zoom_level: 5,
  },
  {
    short_name: 'ACT',
    long_name: 'Australian Capital Territory',
    center_location: {
      lat: -35.5,
      lng: 149,
    },
    zoom_level: 9,
  },
  {
    short_name: 'VIC',
    long_name: 'Victoria',
    center_location: {
      lat: -37,
      lng: 144,
    },
    zoom_level: 6,
  },
  {
    short_name: 'TAS',
    long_name: 'Tasmania',
    center_location: {
      lat: -42,
      lng: 146,
    },
    zoom_level: 7,
  },
  {
    short_name: 'SA',
    long_name: 'South Australia',
    center_location: {
      lat: -31,
      lng: 135,
    },
    zoom_level: 5,
  },
  {
    short_name: 'WA',
    long_name: 'Western Australia',
    center_location: {
      lat: -26,
      lng: 120,
    },
    zoom_level: 5,
  },
  {
    short_name: 'NT',
    long_name: 'Northern Territory',
    center_location: {
      lat: -18,
      lng: 134,
    },
    zoom_level: 5,
  },
];

const getGoogleMapsApiKey = () =>
  process.env[
    `REACT_APP_GOOGLE_MAPS_API_KEY_${process.env.REACT_APP_API}`.toUpperCase()
  ];
export const GOOGLE_MAPS_API_KEY = getGoogleMapsApiKey();
export const LOCAL_SERVICE_AREA_RADIUS_KM = 30;
// *************************************************************
// Geography
// *************************************************************
export const SOUTH_POLE = {
  lat: -88,
  lng: -99,
};

// *************************************************************
// Sort Directions
// *************************************************************
export const SORT_DIRECTIONS = {
  ASC: 'ascending',
  DESC: 'descending',
};

export const API_SUCCESS_MESSAGES = {
  BUSINESS_UPDATED: 'Business details updated successfully',
  PROFILE_UPDATED: 'Profile updated successfully',
};

export const IMAGE_SIZE_LIMIT = 5 * 1000 * 1024; // 5mb
export const IMAGE_SIZE_LIMIT_MESSAGE =
  'File is too big!, Maximum allowed size is 5 MB';

export const FILE_TYPE_ERROR = 'Only image files are supported';
